import React from "react";
import styles from "./index.module.scss";
import { NoDataFoundProps } from "./no-data-found.interface";
import { getDashboardNotFoundMessage } from "../../../utils/utils";
const NoDataFoundC = (props: NoDataFoundProps) => {
  const { title, subTitle, imageUrl, panelName }: any =
    getDashboardNotFoundMessage(props.panelIndex);
  return (
    <div
      className={`${styles.nodata} ${
        props.properties ? styles.properties : ""
      }`}
    >
      {/* <img src={imageUrl} alt={panelName} /> */}
      <div className={styles.heading}>
        <p className={styles.title}>{props.title || title}</p>
        <p className={styles.subtitle}>{props.subTitle || subTitle}</p>
      </div>
    </div>
  );
};

export default React.memo(NoDataFoundC);
